import {
  Skeleton,
  styled,
  TableCell,
  TableRow,
  TableContainer,
  OutlinedInput,
} from '@mui/material';

export const StyledSkeleton = styled(Skeleton)(({theme}) => ({
  margin: theme.spacing(0.5),
  '&.MuiSkeleton-root': {
    height: 24,
  },
}));

export const StyledBodyCell = styled(TableCell)(({theme}) => ({
  border: 0,
  zIndex: 0,
  borderBottom: '1px solid #DFE5E2',
  '&:not(:last-child)': {
    borderRight: '1px solid #DFE5E2',
  },
  '&.MuiTableCell-root': {
    backgroundColor: 'white',
    padding: 0,
    '& > *': {
      padding: theme.spacing(1),
    },
  },
}));

export const StyledHeadCell = styled(TableCell)(({theme}) => ({
  whiteSpace: 'normal',
  border: 0,
  backgroundColor: '#F2F5F4',
  borderBottom: '1px solid #DFE5E2',
  textAlign: 'center',
  maxWidth: '140px',
  minWidth: '140px',
  '&.MuiTableCell-root': {
    padding: '5px',
    '& > *': {
      padding: theme.spacing(1),
    },
  },
  '&:not(:last-child)': {
    borderRight: '1px solid #DFE5E2',
  },
  '.MuiTypography-root': {
    fontWeight: 'bold',
  },
}));

export const StyledFooterCell = styled(TableCell)(({theme}) => ({
  whiteSpace: 'nowrap',
  border: 0,
  backgroundColor: '#F2F5F4',
  borderTop: '1px solid #DFE5E2',
  '&.MuiTableCell-root': {
    padding: theme.spacing(1),
  },
  '.MuiTypography-root': {
    fontWeight: 'bold',
  },
}));

export const StyledTableRow = styled(TableRow)(() => ({
  '&.MuiTableRow-root': {
    padding: 0,
    border: 0,
    height: '28px !important',
    backgroundColor: 'white',
  },
}));

export const StyledTableContainer = styled(TableContainer)(({theme}) => ({
  maxHeight: 'calc(100% - 84px)',
  marginBottom: theme.spacing(3),
  marginLeft: theme.spacing(3),
  marginRight: theme.spacing(3),
  width: 'calc(100% - 48px)',
  border: '1px solid #DFE5E2',
  borderRadius: '8px',
}));

export const StyledOutlinedInput = styled(OutlinedInput)(({theme}) => ({
  '.MuiInputBase-input': {
    width: '270px',
    height: '24px',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
}));
